export const gitCommit = 'ea0897cc'
